import React from 'react';
import MainLayout from './pages/layouts/MainLayout';
import Router from './Router';

function App() {
    return <Router />;
}

export default App;
